module.exports = __webpack_public_path__ + "static/media/mermaid-story.b1fedd3c.md";